export const Discover = [
  {
    id: 1,
    name: "Medicine",
    image:
      "https://assets.pharmeasy.in/apothecary/images/medicine_ff.webp?dim=256x0",
    off: "UPTO 20% OFF",
  },
  {
    id: 2,
    name: "Lab Tests",
    image:
      "https://assets.pharmeasy.in/apothecary/images/labtest_ff.webp?dim=256x0",
    off: "UPTO 70% OFF",
  },
  {
    id: 3,
    name: "Healthcare",
    image:
      "https://assets.pharmeasy.in/apothecary/images/healthcare_ff.webp?dim=256x0",
    off: "UPTO 60% OFF",
  },
  {
    id: 4,
    name: "Surgeries",
    image:
      "https://assets.pharmeasy.in/apothecary/images/offers_1_ff.webp?dim=256x0",
    off: "UPTO 10% OFF",
  },
  {
    id: 5,
    name: "Health Blogs",
    image:
      "https://assets.pharmeasy.in/apothecary/images/health_blogs_ff.webp?dim=256x0",
    off: "UPTO 20% OFF",
  },
  {
    id: 6,
    name: "PLUS",
    image:
      "https://assets.pharmeasy.in/apothecary/images/plus_ff.webp?dim=256x0",
    off: "SAVE 5% EXTRA",
  },
  {
    id: 7,
    name: "Offers",
    image:
      "https://assets.pharmeasy.in/apothecary/images/offers_ff.webp?dim=256x0",
    off: "UPTO 20% OFF",
  },
  {
    id: 8,
    name: "Value Store",
    image:
      "https://assets.pharmeasy.in/apothecary/images/value_store.png?dim=256x0",
    off: "UPTO 50% OFF",
  },
];

export const Slider2Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/aae8bda2f04-STAR25.jpg",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/4a92abd3133-yayy550_bau.jpg",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/048facc8065-634x274a.jpg",
  },
  {
    id: 4,

    image: "https://cdn01.pharmeasy.in/dam/banner/banner/b31ed8123b6-CP.jpg",
  },
  {
    id: 5,

    image:
      " https://cdn01.pharmeasy.in/dam/banner/banner/1ef60ed33e9-VicksWinterBannerfinal.jpg",
  },

  // https://cdn01.pharmeasy.in/dam/banner/banner/1ef60ed33e9-VicksWinterBannerfinal.jpg
];

export const Slider3Link = [
  {
    id: 1,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/10dfe8c8aa7-HealthCheckups.jpg?dim=256x0",
  },
  {
    id: 2,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/6c5479c6c0c-Vitamins.jpg?dim=256x0",
  },
  {
    id: 3,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/69588f95674-Diabetes.jpg?dim=256x0",
  },
  {
    id: 4,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/c507b2563fd-thyroid.png?dim=256x0",
  },
  {
    id: 5,

    image:
      " https://cms-contents.pharmeasy.in/homepage_top_categories_images/eeb3fe3251f-WomenCare.jpg?dim=256x0",
  },
  {
    id: 6,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/355e9b77fb5-FeverInfection.jpg?dim=256x0",
  },
  {
    id: 7,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/6e78a241e48-CovidCare.jpg?dim=256x0",
  },
  {
    id: 8,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/a953829ca96-Heart.jpg?dim=256x0",
  },
  {
    id: 9,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/94616a36a9a-Lifestyle.jpg?dim=256x0",
  },
  {
    id: 10,

    image:
      " https://cms-contents.pharmeasy.in/homepage_top_categories_images/64444851b5e-BoneHealth.jpg?dim=256x0",
  },

  // https://cdn01.pharmeasy.in/dam/banner/banner/1ef60ed33e9-VicksWinterBannerfinal.jpg
];

export const OfferSlider4Link = [
  {
    id: 1,

    image:
      "https://cms-contents.pharmeasy.in/offer/794679adf6a-Offer_YES.jpg?dim=1440x0",
    name: "Flat 25% OFF + FREE Delivery on medicines",
  },
  {
    id: 2,

    image:
      "https://cms-contents.pharmeasy.in/offer/794679adf6a-Offer_YES.jpg?dim=1440x0",
    name: "Get FREE Delivery",
  },
  {
    id: 3,

    image:
      "https://cms-contents.pharmeasy.in/offer/794679adf6a-Offer_YES.jpg?dim=1440x0",
    name: "Flat 27% OFF + FREE Delivery on medicines",
  },
  {
    id: 4,

    image:
      "https://cms-contents.pharmeasy.in/offer/794679adf6a-Offer_YES.jpg?dim=1440x0",
    name: "Flat 25% OFF + FREE Delivery on medicines",
  },
  {
    id: 5,

    image:
      " https://cms-contents.pharmeasy.in/offer/beff77d2d65-Diagnostics-11-min.png?dim=1440x0",
    name: "Get FLAT Rs.1000 OFF on booking 2",
  },
  {
    id: 6,

    image:
      "https://cms-contents.pharmeasy.in/offer/7e9e0fac720-1_400x400_10KB.jpg?dim=1440x0",
    name: "Get FLAT Rs.350 OFF on orders above Rs 1499.",
  },
  {
    id: 7,

    image:
      "https://cms-contents.pharmeasy.in/offer/30c8d4a2e82-400x400.png?dim=1440x0",
    name: "Get FLAT Rs.550 OFF",
  },
  {
    id: 8,

    image: "https://cms-contents.pharmeasy.in/offer/432848472a7-pluslogo.jpg",
    name: "Get Free Plus membership by booking any",
  },
  {
    id: 9,

    image:
      "https://cms-contents.pharmeasy.in/offer/23881b129f7-LOGO.jpg?dim=1440x0",
    name: "FLAT 15% OFF on medicines + up to Rs.250",
  },
  {
    id: 10,

    image:
      "https://cms-contents.pharmeasy.in/offer/e11270f3e3f-paytmcashbackoptimized.png?dim=1440x0",
    name: "Get 3000 cashback points",
  },

  // https://cdn01.pharmeasy.in/dam/banner/banner/1ef60ed33e9-VicksWinterBannerfinal.jpg
];

export const PaymentSlider5Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/a93d45ef9eb-HSBC.jpg?dim=1440x0",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/f3c446e4108-AMAZON.jpg?dim=1440x0",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/9466405c308-au.jpg?dim=1440x0",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/0c5c9ec6841-mobikwik.jpg?dim=1440x0",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/7297689b914-AIRTEL.jpg?dim=1440x0",
  },
];

export const CategoriesSlider6Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/a7a03f6764393c65bab22e56de576a59.png?f=png?dim=256x0",
    name: "Mega clearance sale",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/1e622b0308ec3ab48887512eaa3488a5.png?f=png?dim=256x0",
    name: "Personal care",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/cfc8ee511609321e91eb86a34f5b2885.png?f=png?dim=256x0",
    name: "Healthcare devices",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/335dae76832d370c94f0440f5ba89e1f.png?f=png?dim=256x0",
    name: "Health food and drinks",
  },
  {
    id: 5,

    image:
      " https://cdn01.pharmeasy.in/dam/discovery/categoryImages/dc96175686f135b5a22d1e57165d0246.png?f=png?dim=256x0",
    name: "Home care",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/f692f7243b8036ed97d99a7973dd42b3.png?f=png?dim=256x0",
    name: "Mother and baby care",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/154dec0567b23244b7dcbf2158d39eee.png?f=png?dim=256x0",
    name: "Skin Care",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/514d0d7d01a63502b4ebfec9ae26f4d2.png?f=png?dim=256x0",
    name: "Fitness supplements",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/d1b29f7a2b5f3d62a3d47b617aceef1b.png?f=png?dim=256x0",
    name: "Sexual wellness",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/ecad9a974e003fb987858b3ee81413c6.png?f=png?dim=256x0",
    name: "Ayurvedic care",
  },

  {
    id: 11,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/105ceca515ee30509f93309ae75306aa.png?f=png?dim=256x0",
    name: "Diabetic care",
  },
  {
    id: 12,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/b1a199bf20a9325798872b8685114856.png?f=png?dim=256x0",
    name: "Health condition",
  },
  {
    id: 13,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/763b558b32313005bc11d0cae0e26f58.png?f=png?dim=256x0",
    name: "Accessories & wearables",
  },
  {
    id: 14,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/403b8ada7b113c7cb2e8d09e3420edfa.png?f=png?dim=256x0",
    name: "Beauty",
  },
  {
    id: 15,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/fa936f30b4563fc4abd187fb22fe5258.png?f=png?dim=256x0",
    name: "Elderly care",
  },
  {
    id: 16,

    image:
      "https://cdn01.pharmeasy.in/dam/discovery/categoryImages/f10917087a483040b557e4b18204312c.png?f=png?dim=256x0",
    name: "Top products",
  },

  // https://cdn01.pharmeasy.in/dam/banner/banner/1ef60ed33e9-VicksWinterBannerfinal.jpg
];

export const LaunchesSlider7Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/N25381/stayfree-cottony-xl-18s-2-1666017828.jpg?dim=1440x0",
    name: "Stayfree Cottony Xl 18s",
    Mrp: "MRP $1200",
    price: "108",
    off: "10% OFF",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/O80793/pharmeasy-ironfolic-acid-with-zinc-vitamin-c-b12-maintains-overall-health-bottle-of-60-2-1668672053.jpg?dim=1440x0",
    name: "Pharmeasy Iron+folic Acid ",
    Mrp: "MRP $500",
    price: "$108",
    off: "50% OFF",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/K65441/durex-extra-time-condoms-for-men-10-count-pack-of-10-2-1656075790.jpg?dim=1440x0",
    name: "Durex Extra Time Condoms",
    Mrp: "MRP $245",
    price: "$220",
    off: "10% OFF",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Q09465/pediflor-kidz-natural-orange-toothpaste-70-g-1-1670314184.jpg?dim=1440x0",
    name: "Pediflor Kidz Natural Orange",
    Mrp: "MRP $1200",
    price: "108",
    off: "10% OFF",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/X79195/liveasy-surgicals-rolled-bandage-pack-of-12-10cmx3mt-2-1653648101.jpg?dim=1440x0 ",
    name: "Liveasy Surgical's Rolled",
    Mrp: "MRP $900",
    price: "$345",
    off: "10% OFF",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/T56472/cipla-vc15-vitamin-c-serum-15-ml-2-1670340585.jpg?dim=1440x0",
    name: "Cipla Vc15 Vitamin C Serum ",
    Mrp: "MRP $1200",
    price: "108",
    off: "10% OFF",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/E52686/liveasy-surgicals-rolled-bandage-pack-of-12-5cm-x-3mt-2-1653648071.jpg?dim=1440x0",
    name: "Liveasy Surgical's Rolled",
    Mrp: "MRP $1000",
    price: "$185",
    off: "10% OFF",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/V27328/upglam-shower-gel-200-ml-2-1667570178.jpg?dim=1280x0",
    name: "Upglam Shower Gel- 200 Ml",
    Mrp: "MRP $109",
    price: "$109",
    off: "0% OFF",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/A03114/fixderma-kairfoll-anti-hair-loss-shampoo-200ml-2-1651835079.jpg?dim=1280x0",
    name: "Fixderma Kairfoll Anti Hair",
    Mrp: "MRP $925",
    price: "$832",
    off: "15% OFF",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/O77652/mamypoko-pants-standard-medium-32-diapers-6-1666152302.jpg?dim=1280x0",
    name: "Mamypoko Pants Standard",
    Mrp: "MRP $390",
    price: "$399",
    off: "0% OFF",
  },

  {
    id: 11,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/H53428/skinnsi-happy-hydrate-ceramide-face-moisturizer-2-1666004089.jpg?dim=1280x0",
    name: "Skinnsi Happy Hydrate",
    Mrp: "MRP $390",
    price: "$319",
    off: "20% OFF",
  },
];

export const TrendingSlider8Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I05582/dr-morepen-gluco-one-bg-03-glucometer-test-strips-box-of-50-1-1669655233.jpg?dim=1440x0",
    name: "Dr Morepen Gluco One",
    Mrp: "MRP $800",
    price: "$648",
    off: "20% OFF",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Q83701/pharmeasy-all-in-one-vaporizer-1-1654233812.jpg?dim=1440x0",
    name: "Pharmeasy All-in -one Vaporizer ",
    Mrp: "MRP $590",
    price: "$268",
    off: "50% OFF",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/266249/depura-60000-iu-vitamin-d3-oral-solution-helps-bones-healthy-aids-in-boosting-immunity-sugarfree-2-1669616992.jpg?dim=1440x0",
    name: "Depura 60000 Iu Vitamin ",
    Mrp: "MRP $95",
    price: "$20",
    off: "80% OFF",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/226830/prega-news-pregnancy-test-kit-1-1669655006.jpg?dim=1440x0",
    name: "Prega News Pregnancy ",
    Mrp: "MRP $120",
    price: "108",
    off: "10% OFF",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/149350/refresh-tears-05-bottle-of-10ml-eye-drops-1-1669616622.jpg?dim=1440x0",
    name: "Everherb Karela Jamun juice",
    Mrp: "MRP $399",
    price: "$345",
    off: "20% OFF",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/000665/accu-chek-active-glucometer-test-strips-box-of-50-1-1669655023.jpg?dim=1440x0",
    name: "Accu-chek Active Glucometer ",
    Mrp: "MRP $1049",
    price: "$902.14",
    off: "14% OFF",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Q16893/liveasy-ortho-care-cotton-crepe-bandage-reduces-strain-sprain-swelling-10-cms-x-4-meters-2-1656420284.jpg?dim=1440x0",
    name: "Liveasy Ortho Care Cotton",
    Mrp: "MRP $225",
    price: "$185",
    off: "10% OFF",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/181135/vicks-vaporub-25ml-relief-from-cold-cough-headache-and-body-pain-2-1669655043.jpg?dim=1440x0",
    name: "Vicks Vaporub 25ml Relief",
    Mrp: "MRP $99",
    price: "$89",
    off: "10% OFF",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/038124/cetaphil-oily-skin-cleanser-125ml-2-1669619400.jpg?dim=1280x0",
    name: "Cetaphil Oily Skin Cleanser",
    Mrp: "MRP $525",
    price: "$432",
    off: "25% OFF",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/192351/i-pill-tab-2-1669616971.jpg?dim=1280x0",
    name: "Prega News Pregnancy",
    Mrp: "MRP $60",
    price: "$49",
    off: "15% OFF",
  },

  {
    id: 11,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/149350/refresh-tears-05-bottle-of-10ml-eye-drops-1-1669616622.jpg?dim=1280x0",
    name: "Refresh Tears 0.5% Bottle Of ",
    Mrp: "MRP $190",
    price: "$111",
    off: "40% OFF",
  },
];

export const ShopConcernLink = [
  {
    id: 1,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/923a665cc6f-Skin_care.png?dim=128x0",
    name: "Skin Care",
  },
  {
    id: 2,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/18d2e2ee86b-Vitamins.png?dim=128x0",
    name: "Vitamins & Supplemen",
  },
  {
    id: 3,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/0af9ac9f350-Diabetes.webp?dim=128x0",
    name: "Diabetes Care",
  },
  {
    id: 4,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/24a0d2c733e-Heart.webp?dim=128x0",
    name: "Cardiac Care",
  },
  {
    id: 5,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/68369c9df98-Pregnancy.webp?dim=128x0",
    name: "Baby & Mom ",
  },
  {
    id: 6,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/16ab65c0826-Covid.webp?dim=128x0",
    name: "Covid Care",
  },
  {
    id: 7,

    image:
      "https://cms-contents.pharmeasy.in/homepage_top_categories_images/26bbd7a9e98-Lifestyle.webp?dim=128x0",
    name: "Lifestyle Disorders",
  },
];

export const FrequentlyLink = [
  {
    id: 1,

    image:
      "https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/01abb07c5b233f90b2cd0b64a7ebccee.png?dim=96x0",
    name: "Comprehensive Full Body Checkup with Vitamin D & B12 ",
    des: "Measures Vitamin D & B12 levels and other essential parameters",
    off: "63% OFF",
    price: "$1549",
    cut: "$4199",
  },
  {
    id: 2,

    image:
      "https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/c4162b4ec00938379d15b2719577457e.png?dim=96x0",
    name: "Healthy 2022 Full Body Checkup with Full value",
    des: "Diagnostic tool for screening and monitoring of your health",
    off: "64% OFF",
    price: "$1049",
    cut: "$2990",
  },
  {
    id: 3,

    image:
      "https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/4ff607383fad35e4af5639c3e7709734.png?dim=96x0",
    name: "Basic Health Checkup with advance Technology",
    des: "Assesses health of 47 essential body",
    off: "64% OFF",
    price: "$725",
    cut: "$2050",
  },
  {
    id: 4,

    image:
      "https://s3.ap-south-1.amazonaws.com/pe-neon-public/diagnostics/production/recommendationWidget/4ff607383fad35e4af5639c3e7709734.png?dim=96x0",
    name: "C-Reactive Protein - Quantitative (CRP)",
    des: "Predicts the risk of heart-problems",
    off: "64% OFF",
    price: "$750",
    cut: "$425",
  },
];

export const WellnessSlider11Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/O22179/hansaplast-fixation-tape-25-cm-x-914-cm-1-1654250475.jpg?dim=1440x0",
    name: "Hansaplast Fixation Tape 2.5 Cm X 914 Cm",
    Mrp: "MRP $83",
    price: "$64",
    off: "20% OFF",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/181135/vicks-vaporub-25ml-relief-from-cold-cough-headache-and-body-pain-2-1669655043.jpg?dim=1440x0",
    name: "Vicks Vaporub 25ml Relief From Cold Cough",
    Mrp: "MRP $90",
    price: "$68",
    off: "5% OFF",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/products/375380/nasivion-classic-adult-nasal-spray-10ml-1-1641536452.jpg?dim=1440x0",
    name: "Nasivion Classic Adult Nasal Spray 10ml",
    Mrp: "MRP $95",
    price: "$78",
    off: "8% OFF",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/T60720/pharmeasy-multivitamin-multimineral-immunity-booster-complete-nutrition-bottle-of-60-2-1670824799.jpg?dim=1440x0",
    name: "Pharmeasy Multivitamin Multimineral - Immunity",
    Mrp: "MRP $690",
    price: "$384",
    off: "45% OFF",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/270551/revital-h-men-multivitamin-with-zinc-ginseng-for-immunity-strong-bones-energy-10-capsules-1-1669617102.jpg?dim=1440x0",
    name: "Revital H Men Multivitamin With Zinc & Ginseng For",
    Mrp: "MRP $119",
    price: "$95",
    off: "15% OFF",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/227623/sevenseas-original-capsule-100s-1-1669616952.jpg?dim=1440x0",
    name: "Sevenseas Original Capsule 100`s",
    Mrp: "MRP $351",
    price: "$280",
    off: "24% OFF",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/O31911/everherb-by-pharmeasy-ashwagandha-immunity-booster-capsules-anxiety-stress-relief-bottle-of-60-2-1661760071.jpg?dim=1440x0",
    name: "Everherb (by Pharmeasy) Ashwagandha - Immunity",
    Mrp: "MRP $599",
    price: "$311",
    off: "48% OFF",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I47500/hansaplast-spot-bandage-jar-of-50-2-1669711300.jpg?dim=1440x0",
    name: "Hansaplast Spot Bandage Jar Of 50",
    Mrp: "MRP $100",
    price: "$73",
    off: "27% OFF",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/E85132/liveasy-wellness-vitamin-c-990mg-with-zinc-10mg-powerful-immunity-booster-60-veg-tablets-2-1661760130.jpg?dim=1440x0",
    name: "Liveasy Wellness Vitamin C (990mg) With Zinc",
    Mrp: "MRP $799",
    price: "$399",
    off: "50% OFF",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/U97974/everherb-giloy-tulsi-juice-strengthens-body-defence-system-natural-immunity-booster-1-litre-2-1654233486.jpg?dim=1440x0",
    name: "Everherb Giloy Tulsi Juice - Strengthens Body",
    Mrp: "MRP $399",
    price: "$359",
    off: "15% OFF",
  },
];

export const FeaturedLink = [
  {
    id: 1,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/a559f294d43-Vicks-min.png?dim=1440x0",
    name: "Vicks",
  },
  {
    id: 2,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/3eb4eb6bfbe-App_Himalaya.jpg?dim=1440x0",
    name: "Himalaya",
  },
  {
    id: 3,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/40facc7fa28-Pharmeasy-App.jpg?dim=1440x0",
    name: "Pharmeasy",
  },
  {
    id: 4,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/7a381fcb6e9-App_dettol-min.png?dim=1440x0",
    name: "Dettol",
  },
  {
    id: 5,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/1466c422fcd-Sugerfree.png?dim=1440x0",
    name: "Sugar Free ",
  },
  {
    id: 6,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/62668bab7a1-AccuChek-min.png?dim=1440x0",
    name: "Accu-Check",
  },
  {
    id: 7,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/d0f595be419-Savlonv2.png?dim=1440x0",
    name: "Savlon",
  },

  {
    id: 8,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/3c344faad99-App_Featured-J.jpg?dim=1440x0",
    name: "Johnson's ",
  },
  {
    id: 9,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/201210bc27d-App_Huggies.jpg?dim=1280x0",
    name: "Huggies",
  },
  {
    id: 10,

    image:
      "https://cms-contents.pharmeasy.in/carousel_item/d3481485e73-App_stayfree.jpg?dim=1280x0",
    name: "Stayfree",
  },
];

export const OnlyImgLink = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/fcbf95577c3-VELCRO.jpg?dim=1440x0",
    name: "Vicks",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/a9ad640ce01-4.jpg?dim=1440x0",
    name: "Himalaya",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/93ef9d6df4f-SLIPPERS.jpg?dim=1440x0",
    name: "Pharmeasy",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/6e16a38ea89-ORTHO_PEDOC.jpg?dim=1440x0",
    name: "Dettol",
  },
];

export const DealsSlider11Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/O22179/hansaplast-fixation-tape-25-cm-x-914-cm-1-1654250475.jpg?dim=1440x0",
    name: "Hansaplast Fixation Tape 2.5 Cm X 914 Cm",
    Mrp: "MRP $83",
    price: "$34",
    off: "20% OFF",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I40923/nivea-soft-light-moisturizer-of-200-ml-2-1669711207.jpg?dim=1440x0",
    name: "Nivea Soft Light Moisturizer Of 200 Ml",
    Mrp: "MRP $290",
    price: "$208",
    off: "15% OFF",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Z07796/supradyn-immuno-multivitamin-natural-immunity-booster-with-vit-c-vit-d-zinc-30-tablets-2-1665045164.jpg?dim=1440x0",
    name: "Supradyn Immuno+ Multivitamin Natural",
    Mrp: "MRP $295",
    price: "$278",
    off: "8% OFF",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/D44788/cremaffin-trial-stick-pack-of-15ml-pack-of-5-mint-2-1651912372.jpg?dim=1440x0",
    name: "Cremaffin Trial Stick Pack Of 15ml (pack Of)",
    Mrp: "MRP $90",
    price: "$84",
    off: "45% OFF",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I41687/nivea-soft-light-moisturizer-of-100-ml-2-1669710876.jpg?dim=1440x0",
    name: "Nivea Soft Light Moisturizer Of 100 Ml",
    Mrp: "MRP $169",
    price: "$147",
    off: "15% OFF",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/211685/vantej-toothpaste-for-hypersensitive-teeth-tube-of-100-g-1-1669616697.jpg?dim=1440x0",
    name: "Vantej Toothpaste For Hypersensitive Teeth Tube Of 100 G",
    Mrp: "MRP $351",
    price: "$280",
    off: "24% OFF",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I04064/depiwhite-tube-of-15ml-eye-contour-gel-1-1669654999.jpg?dim=1440x0",
    name: "Depiwhite Tube Of 15ml Eye Contour Gel",
    Mrp: "MRP $599",
    price: "$311",
    off: "48% OFF",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/X29203/liveasy-ortho-care-acupressure-slippers-men-black-size-10-2-1654249562.jpg?dim=1440x0",
    name: "Liveasy Ortho Care Acupressure Slippers ",
    Mrp: "MRP $500",
    price: "$480",
    off: "27% OFF",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/I26961/johnsons-baby-soap-wrap-of-75-g-2-1669710433.jpg?dim=1440x0",
    name: "Johnson's Baby Soap Wrap Of 75 G",
    Mrp: "MRP $69",
    price: "$39",
    off: "50% OFF",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Z07796/supradyn-immuno-multivitamin-natural-immunity-booster-with-vit-c-vit-d-zinc-30-tablets-2-1665045164.jpg?dim=1440x0",
    name: "Supradyn Immuno+ Multivitamin Natural Immunity Booster With",
    Mrp: "MRP $2709",
    price: "$240",
    off: "15% OFF",
  },
];

export const SpotlightSlider11Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/L79986/everherb-karela-jamun-juice-helps-maintains-healthy-sugar-levels-helps-in-weight-management-1l-2-1670824840.jpg?dim=256x0",
    name: "Everherb Karela Jamun Juice - Helps Maintains",
    Mrp: "MRP $383",
    price: "$334",
    off: "20% OFF",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/T22634/liveasy-wellness-calcium-magnesium-vitamin-d3-zinc-bones-dental-health-bottle-60-tabs-2-1661760061.jpg?dim=256x0",
    name: "Liveasy Wellness Calcium Magnesium",
    Mrp: "MRP $590",
    price: "$308",
    off: "35% OFF",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/Q83701/pharmeasy-all-in-one-vaporizer-1-1654233812.jpg?dim=256x0",
    name: "Pharmeasy All-in -one Vaporizer",
    Mrp: "MRP $595",
    price: "$278",
    off: "58% OFF",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/B39499/pharmeasy-hot-water-bag-blue-2-1656420198.jpg?dim=256x0",
    name: "Pharmeasy Hot Water Bag - Relieves Pain -",
    Mrp: "MRP $390",
    price: "$284",
    off: "35% OFF",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/G67452/pharmeasy-calcium-magnesium-vitamin-d3-zinc-bones-dental-health-bottle-60-2-1656417512.jpg?dim=256x0",
    name: "Pharmeasy Calcium Magnesium Vitamin D",
    Mrp: "MRP $269",
    price: "$247",
    off: "15% OFF",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/T60720/pharmeasy-multivitamin-multimineral-immunity-booster-complete-nutrition-bottle-of-60-2-1670824799.jpg?dim=256x0",
    name: "Pharmeasy Multivitamin Multimineral - Immunit",
    Mrp: "MRP $651",
    price: "$380",
    off: "44% OFF",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/D18575/pharmeasy-biotin-bottle-pack-of-60-2-1670500717.jpg?dim=256x0",
    name: "Pharmeasy Biotin Bottle- Pack Of 60",
    Mrp: "MRP $599",
    price: "$381",
    off: "48% OFF",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/E07034/liveasy-wellness-diabetic-protein-blood-sugar-weight-management-french-vanilla-400g-jar-2-1654169670.jpg?dim=256x0",
    name: "Liveasy Ortho Care Acupressure SlippersLiveasy Wellness Diabetic Protein - Blo ",
    Mrp: "MRP $900",
    price: "$480",
    off: "57% OFF",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/D52223/liveasy-foods-healthy-roasted-seed-mix-blend-of-6-fibre-rich-healthy-roasted-seeds-200-gms-2-1656420865.jpg?dim=256x0",
    name: "Liveasy Foods Healthy Roasted Seed Mix ",
    Mrp: "MRP $369",
    price: "$199",
    off: "50% OFF",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/products_otc/E16289/pharmeasy-orthopaedic-electric-heat-belt-regular-2-1654251860.jpg?dim=256x0",
    name: "Pharmeasy Orthopaedic Electr",
    Mrp: "MRP $2709",
    price: "$840",
    off: "15% OFF",
  },
];

export const OnlyImg2Link = [
  {
    id: 1,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/810889b6613-babycare-min.png?dim=1440x0",
    name: "Vicks",
  },
  {
    id: 2,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/5e9dc201ab9-DevicesClearanceStore.jpg?dim=1440x0",
    name: "Himalaya",
  },
  {
    id: 3,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/ed87375d79f-DiabeticCare-min.png?dim=1440x0",
    name: "Pharmeasy",
  },
  {
    id: 4,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/ee420d12d95-category_Sexual-wellnes.jpg?dim=1440x0",
    name: "Dettol",
  },
  {
    id: 5,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/d91d8a17483-b80e93634e8-Now-never_CB.jpg?dim=1440x0",
    name: "Vicks",
  },
  {
    id: 6,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/041c47e32a2-CB_Beauty.jpg?dim=1440x0",
    name: "Himalaya",
  },
  {
    id: 7,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/9b42ab4d9ab-home-page-banner_nutrition-.jpg?dim=1440x0",
    name: "Pharmeasy",
  },
  {
    id: 8,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/cea76587546-Personal-care_c.jpg?dim=1440x0",
    name: "Dettol",
  },
  {
    id: 9,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/9452a363f7f-covid-19.jpg?dim=1440x0",
    name: "Pharmeasy",
  },
  {
    id: 10,

    image:
      "https://cdn01.pharmeasy.in/dam/banner/banner/cea76587546-Personal-care_c.jpg?dim=1440x0",
    name: "Dettol",
  },
];

export const HealthArticlesLink = [
  {
    id: 1,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/12/15110420/1-9.jpg?dim=1440x0",
    name: "Avighna Medicare Pvt Ltd",
  },
  {
    id: 2,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/10/06124619/10-2.jpg?dim=1440x0",
    name: "Benefits of Shalabhasana (Locust Pose) and How to Do it By Dr. Himani Bisht",
  },
  {
    id: 3,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/12/12104633/1-8.jpg?dim=1440x0",
    name: "How Exercise Can Help You Deal With Breast Cancer",
  },
  {
    id: 4,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/12/06111050/11-1.jpg?dim=1440x0",
    name: "Benefits of Natarajasana (Dancer Pose) and How to Do it By Dr. Ankit Sankhe",
  },
  {
    id: 5,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/11/06122433/28.jpg?dim=1440x0",
    name: "Goji Berry: Uses, Benefits, Side Effects By Dr. Rajeev Singh",
  },
  {
    id: 6,

    image:
      "https://blog-images-1.pharmeasy.in/blog/production/wp-content/uploads/2022/11/06122833/4-15.jpg?dim=1440x0",
    name: "Avocado Oil: Uses, Benefits, Side Effects By Dr. Rajeev Singh",
  },
];

export const ChooseLink = [
  {
    id: 1,

    image: "https://assets.pharmeasy.in/apothecary/images/family.svg?dim=96x0",
    name: "32 Million+",
    des: "Registered users as of Mar 31, 2022",
  },
  {
    id: 2,

    image:
      "https://assets.pharmeasy.in/apothecary/images/deliveryBoy.svg?dim=96x0",
    name: "36 Million+",
    des: "Orders on Pharmeasy till date ",
  },
  {
    id: 3,

    image:
      "https://assets.pharmeasy.in/apothecary/images/pincodeServed.svg?dim=96x0",
    name: "99000+",
    des: "Unique items sold last 3 months",
  },
  {
    id: 4,

    image:
      "https://assets.pharmeasy.in/apothecary/images/locationMarker.svg?dim=96x0",
    name: "19500+",
    des: "Pin codes serviced last 3 months",
  },
  ,
  {
    id: 5,

    image:
      "https://assets.pharmeasy.in/apothecary/images/locationMarker.svg?dim=96x0",
    name: "29500+",
    des: "Pined codes serviced last 8 months",
  },
];

export const CustomerLink = [
  {
    id: 1,

    date: "April 22, 2022",
    name: "Rajarshi Sarkar ",
    des: "The app is really wonderful. Being a Product Manager myself, I would say that the User experience (UI/UX) of the app is top notch (easy to use, simple and convenient). Coming to services and delivery, I would say Pharmeasy is doing a tremendous job even during this unprecedented pandemic situation.",
  },
  {
    id: 2,

    date: "April 23, 2022",
    name: "Darpan Dholakia",
    des: "Best service and app amongst all available. I have been using it for more than 3 years, and even during the pandemic, they have kept their standards high and are delivering the order within 24 hours. Keep up the good work.",
  },
  {
    id: 3,

    date: "April 15, 2022",
    name: "Lipi Chaudhuri",
    des: "This app is a game changer for me. I am unable to go out always to buy medicinal products. Pharmeasy gives me the last liberty to shop essential healthcare products from home. The app is very user friendly and me being an elderly person do not find any difficulty in using it. They deliver well in time. Thanks😊",
  },
  {
    id: 4,

    date: "April 23, 2022",
    name: "Tirthankar Das Purkayastha",
    des: "Very good app. Would recommend it to everyone requiring fast and efficient delivery of medicinal products at the doorstep.",
  },
  {
    id: 5,

    date: "April 23, 2022",
    name: "Varun Sonagra",
    des: "I've had a good experience. The consultation with a doctor feature works well too. The prices and discounts are great too. Overall the simplicity of the app is a plus too. I recommend this app. Will always be a customer/user now! Genuinely!",
  },
  {
    id: 6,

    date: "April 18, 2022",
    name: "Debanjan Roy",
    des: "Excellent experience. Pharmeasy has not let it's customers down during lockdown. Thanks team. Great job. The application is also very smooth. And does its job well with an attractive UI and easy to use features. Good job developer.",
  },
  {
    id: 7,

    date: "April 21, 2022",
    name: "Rohini Sarkar",
    des: "Very helpful and friendly app in terms of usability, customer support & money saving from the point of medical necessity of every person.",
  },
];
